// extracted by mini-css-extract-plugin
export default {"component":"aPiGt","append":"IR4rr","loader":"CQoCm"};